import { Icon, NavLink } from '@inflearn/ds-react';
import { faChevronRight } from '@inflearn/pro-regular-svg-icons';
import { isNil } from 'lodash-es';

import { INFLEARN_B2B_URL } from '../../../constants/urls';
import useClientAccountProfileQuery from '../../../queries/useClientAccountProfileQuery';
import { getB2BRole } from '../../../utils/getB2BRole';
import { LinkCategoryTitle, NavLinkList } from './LNB';

export function B2BMenus() {
  const { data: profile, isLoading } = useClientAccountProfileQuery({
    useErrorBoundary: false,
    refetchOnWindowFocus: false,
  });

  if (isLoading || isNil(profile)) {
    return null;
  }

  const manageGroupId = profile.managedGroup?.id;
  const { isGroupManager, isGroupMember, isB2BUser } = getB2BRole(profile);

  if (!isB2BUser) {
    return null;
  }

  return (
    <>
      <LinkCategoryTitle>비즈니스</LinkCategoryTitle>
      <NavLinkList>
        {isGroupManager && manageGroupId && (
          <NavLink
            component="a"
            label="비즈니스 관리"
            href={INFLEARN_B2B_URL.ORDERS(manageGroupId)}
            rightSection={<Icon icon={faChevronRight} />}
            target="_blank"
          />
        )}
        {isGroupMember && (
          <NavLink component="a" label="수강내역" href={INFLEARN_B2B_URL.BIZ_ENROLMENTS()} />
        )}
      </NavLinkList>
    </>
  );
}
